import useLeader from "~/store/Leader"
import usePub from "~/store/Public"
export default defineNuxtRouteMiddleware(async (to, from) => {
    const { ssrContext } = useNuxtApp();

    if (ssrContext) return navigateTo({
        name: "LeaderGroup"
    });

    usePub().loading = true
    const result = await useLeader().checkUser();
    usePub().loading = false

    if (!result.status) {
        return navigateTo({
            name: "LeaderGroup"
        });
    }

})